import BossModel from "@/models/BossModel";
import Dossier from "@/models/Dossier/Dossier";
import User from "@/models/User/User";

export default class Dialogue extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'customer/dialogue';

    /**
     *
     * @type {string}
     */
    static entity = 'customerDialogues';

    static fields() {
		return {
			id: this.attr(null),
			customer_dialogue_template_id: this.number(null).nullable(),
			parent_id: this.number(null).nullable(),
			dossier_id: this.number(null).nullable(),
			send_by_user_id: this.number(null).nullable(),
			title: this.attr(null),
			message: this.attr(null),
			is_read: this.boolean(false),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            dossier: this.belongsTo(Dossier, 'dossier_id'),
            send_by_user: this.belongsTo(User, 'send_by_user_id'),
            parent: this.belongsTo(Dialogue, 'parent_id'),
		}
	}

    static loadByDossier(dossierId){
        return this.api().where('dossier_id', dossierId)
            .limit(0)
            .get();
    }

    SendByUser() {
        return this.getRelated('send_by_user');
    }

    Dossier() {
        return this.getRelated('dossier');
    }

    Parent() {
        return this.getRelated('parent');
    }
}
